import React, { memo, useEffect, useState } from 'react';
import IntegrationCard from './card';
import IntegrationListView from './list';
// import { Button } from 'appkit-react';
import { INTERGTATION_NAV_NAME_DEFAULT } from '@model';
import Tab from '../../integrationHub/manageModules/manageMForm/Tabs';
// import '@style/modules/project/integrationNavigator.scss';
import '../../../../styles/modules/project/integrationNavigator.scss';
import { shouldScrollInToView } from '@components/directUser/utils';
import SectionComment from 'src/ddvComment/SectionComment';
import CommentAnchor from 'src/ddvComment/directUser/CommentAnchor';
import ConcurrentEditButton from '@components/concurrentEditButton';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import useProjectId from '@hooks/useProjectId';
import { setURLSearchParam } from '@utils/history';
import { useHistory } from 'react-router-dom';
import SearchParamKeys from '@model/searchParamKeys';
import PendoIO from '@utils/pendo';
import { checkTabPermission } from '@utils/permission';

const IntegrationNavigator = (props) => {
  const {
    list: integrationModuleList = [],
    name: integrationModuleName,
    tabs,
    onTabChange,
    currentTab,
    identifier,
    handleRefresh,
    groupInfo,
    displayMode,
  } = props;

  const userInfo = JSON.parse(window.localStorage.userInfo || '{}') || {};
  const { isInternal } = userInfo;
  const userId = useSelector((state) => state.login.userInfo.guid);
  const userName = useSelector(
    (state) =>
      `${state.login.userInfo.given_name} ${state.login.userInfo.family_name}`,
  );
  const loading = useSelector(
    ({ projects }) => projects.integrationNavigatorLoading,
  );
  const projectId = useProjectId();
  const history = useHistory();

  const [listOpen, setListOpen] = useState(true);
  const toggleListOpen = () => {
    setListOpen(!listOpen);
  };
  const [noCardInList, setNoCardInList] = useState(false);

  const [tabName, setTabName] = useState();

  const cardLists = noCardInList
    ? []
    : integrationModuleList.filter((e) => e.display);
  // const [cardLists, setCardLists] = useState([]);

  // useEffect(() => {
  //   setCardLists(
  //     noCardInList ? [] : integrationModuleList.filter((e) => e.display),
  //   );
  // }, [noCardInList, integrationModuleList, currentTab]);

  const clearCardList = () => setNoCardInList(true);

  const hasTabPermission = (tabId) => {
    const tabPermission = tabs.find((tab) => tab.id === tabId)?.permission;
    if (tabPermission?.length) {
      return checkTabPermission(tabPermission, groupInfo, userInfo);
    }
    return false;
  };

  useEffect(() => {
    if (currentTab && hasTabPermission(currentTab)) {
      setURLSearchParam(history, {
        [SearchParamKeys.integrationTabId]: currentTab,
      });
    }
    for (const i in tabs) {
      if (tabs[i].id === currentTab) {
        //TODO: add view mode reestriction
        PendoIO.track('Navigation Tab - Access', {
          tab_name: tabs[i].text,
          project_id: projectId,
          uid: userId,
          full_name: userName,
        });
        setTabName(tabs[i].text);
        break;
      }
    }
  }, [currentTab]);

  return (
    <Spin spinning={loading}>
      <div className="integration-navigator integration-tile">
        <div className="title ">
          <span>{integrationModuleName || INTERGTATION_NAV_NAME_DEFAULT}</span>
          <div className="button-with-comment-icon">
            <SectionComment
              module="Project Home"
              component={integrationModuleName || INTERGTATION_NAV_NAME_DEFAULT}
              sendIdentifier={identifier}
              getPopupContainer={
                // () => document.getElementById('root')
                () => document.getElementsByClassName('integration-tile')[0]
              }
              placement="leftTop"
            />
            {isInternal && (
              <ConcurrentEditButton
                buttonProps={{
                  className: 'role-control',
                  size: 'lg',
                  onClick: () => {
                    props.history.push(
                      `/projects/manageTiles?projectId=${projectId}`,
                      {
                        fromProjectHome: true,
                      },
                    );
                    PendoIO.track('Manage Tiles - Enter', {
                      project_id: projectId,
                      uid: userId,
                      full_name: userName,
                    });
                  },
                  children: 'Edit',
                }}
                identifier={identifier}
                handleRefresh={handleRefresh}
                autoRefresh
              />
            )}
          </div>
        </div>
        <Tab
          tabs={tabs}
          editable={false}
          onChange={onTabChange}
          currentTab={currentTab}
          clearCardList={clearCardList}
          groupInfo={groupInfo}
          noRender={tabs?.length <= 1}
        />
        <div
          className={`${displayMode === 'List' ? 'content-list-view' : ''}
          ${listOpen ? 'content list-open ' : 'content'}`}
        >
          {cardLists.length ? (
            displayMode === 'List' ? (
              <IntegrationListView
                tabName={tabName}
                dataList={cardLists}
                listOpen={listOpen}
                key={currentTab}
              />
            ) : (
              cardLists.map((item) => (
                <IntegrationCard
                  key={item.moduleId}
                  data={item}
                  tabName={tabName}
                />
              ))
            )
          ) : (
            <div className="no-data">No Data</div>
          )}
        </div>
        {integrationModuleList.filter((e) => e.display).length > 3 ? (
          <div className="hide-mask" onClick={toggleListOpen}>
            {listOpen ? `Show Less` : `View All`}
            {listOpen ? (
              <span className="appkiticon icon-up-chevron-outline" />
            ) : (
              <span className="appkiticon icon-down-chevron-outline" />
            )}
          </div>
        ) : null}
      </div>
    </Spin>
  );
};

export default memo(
  CommentAnchor(IntegrationNavigator, {
    shouldScrollInToView,
    getAnchorIdFromProp(props) {
      return props.identifier;
    },
  }),
);
